import { memo, useCallback, useEffect, useMemo, useState, } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzModalTitle } from '../../../components';
import ManageColumns from './ManageColumns';
import { toastConfig } from '../../../redux/actions/toast';
import { createUserColumnProfileAction, deleteUserColumnProfileAction, updateStrViewType, updateUserColumnProfileAction } from '../../../redux/actions/watchlist';
import { handleModal } from '../../../redux/actions/modals';
import { useDebounce } from '../../../hooks';
import { API_RESPONSE_STATUS, MANAGE_COLUMNS_VIEW_TYPES } from '../../../utils/global_variables';
import ManageColumnStatusModal from './ManageColumnStatusModal';
import { bIsProd, convertTOVariable, deepClone } from '../../../utils/global_functions';
//Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
import { _checkForSpecialChars } from '../../../controllers';
//Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - End
import BzViewWiseColumnList from '../../../utils/BzViewWiseColumnList.json';

const GridManageColumnsModal = () => {
  const dispatch = useDispatch();
  const modals = useSelector(state => state?.modals?.modals);
  const userColumnProfiles = useSelector(state => state?.watchList?.userColumnProfiles);
  const columnViewType = useSelector(state => state?.watchList?.columnViewType);
  const isColumnPresent = useSelector(state => state?.watchList?.isColumnPresent);
  const objViewWiseColumnProfiles = useSelector(state => state?.watchList?.objViewWiseColumnProfiles);
  const defaultManageColumnName = useSelector(state => state?.watchList?.defaultManageColumnName);
  const arrColumnMoviedTypess = useSelector(state => state?.columns?.arrColumnMoviedTypess);
  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  const copyActiveWatchlist = useSelector(state => state?.watchList?.activeWatchList);
  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - End


  const [selectedProfile, setSelectedProfile] = useState([]);
  const [isDropDown, setIsDropDown] = useState(false);
  const [profileName, setProfileName] = useState('');
  const [isDisabledButton, setIsDisabledButton] = useState(true);
  const [isDisableBtnInSort, setIsDisableBtnInSort] = useState(false);
  const [strMsg, setStrMsg] = useState('');
  const [strModalNameViewType, setStrModalNameViewType] = useState('');
  const [customizeColoumns, setArrManageGridCustomizeColoumns] = useState([

  ]);

  const [selectViewTypeProfiles, setSelectedViewTypePRofile] = useState([]);
  const [arrAllColoumns, setArrAllColumns] = useState([]);
  const [arrFixedColumns, setArrFixedColumns] = useState([]);
  const [selected, setSelected] = useState('');
  const [arrSelectedProfile, setArrSelectedPRofile] = useState([]);

  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  const [isActive, setIsActive] = useState(true);
  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - End
  //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  const [nonFilteredAllColumns, setNonFilteredALlColumns] = useState([]);
  //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - End




  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start

  //Ameersha N: 9-07-2024 : Bt-96552 - Breeze DO NOT DELETE THIS CODE [THIS CODE FOR MULTIPLE COLUMN PROFILE CREATION] --Start
  //Making save and aplly button disable when nothing is selected
  // useEffect(() => {

  // if (selectedProfile?.length > 0 || profileName?.length > 0) {
  //   setIsDisabledButton(false);
  // } else {
  //   setIsDisabledButton(true);
  // }
  // }, [selectedProfile, profileName]);
  //Ameersha N: 9-07-2024 : Bt-96552 - Breeze DO NOT DELETE THIS CODE [THIS CODE FOR MULTIPLE COLUMN PROFILE CREATION] --End
  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End

  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  const activeWatchList = useMemo(() => copyActiveWatchlist, [copyActiveWatchlist]);
  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - End

  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  const handleHide = useCallback(() => {
    dispatch(handleModal([{ "WATCHLIST_MANAGE_COLUMNS_MODAL": false }]));
    setArrManageGridCustomizeColoumns([]);
    setSelectedProfile([]);
    setArrAllColumns([]);
    setStrModalNameViewType('');
    dispatch(updateStrViewType(''));
    setSelected('');
    setIsDropDown(false);
    setIsActive(true);
    setIsDisableBtnInSort(false);

  }, [dispatch]);
  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - End

  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
  //This function will get the all coulmns but based on viewtype it will update allcolumns and fixed columns accordingly
  const setandFixFixedAndAllColumns = useCallback(() => {
    const selectedViewTypePRofile = deepClone(objViewWiseColumnProfiles[columnViewType])?.length > 0 ? deepClone(objViewWiseColumnProfiles[columnViewType]) : BzViewWiseColumnList[columnViewType];
    if (selectedViewTypePRofile?.length > 0) {

      setSelectedViewTypePRofile([...selectedViewTypePRofile]);
      const arrFixed = selectedViewTypePRofile?.filter(each => each?.sSettings?.bIsFixed === 'true');

      arrFixed?.forEach((eachColumn) => {
        eachColumn.sSettings = { ...eachColumn?.sSettings, field: convertTOVariable(eachColumn?.sSettings?.field) };
      });
      // re arrange columns and filter out
      setArrFixedColumns([...arrFixed]);
      let allColumns = selectedViewTypePRofile?.filter(each => each?.sSettings?.bIsFixed === 'false');
      // if no profile present filter out bIsDefault also
      let abc = userColumnProfiles?.filter((eachProfile) => eachProfile?.sViewType === columnViewType);
      //if user has no column prfoiles this iwll help to add defautl columns to custmisable columns
      if (abc?.length === 0) {
        allColumns = allColumns?.filter(each => each?.sSettings?.bIsDefault !== 'true');
        const defaultColumns = selectedViewTypePRofile?.filter(each => each?.sSettings?.bIsDefault === 'true');
        defaultColumns?.forEach((eachColumn) => {
          eachColumn.sSettings = { ...eachColumn?.sSettings, field: convertTOVariable(eachColumn?.sSettings?.field)?.toString() };
        });
        if (arrColumnMoviedTypess?.length > 0) {
          let objMovedColumnType = arrColumnMoviedTypess?.find((obj) => obj?.viewType === columnViewType);
          if (objMovedColumnType) {
            // re arrange and seqence as drag and drop happens only for cusomisable columns
            const result = rearrangeByColumnName(defaultColumns, objMovedColumnType?.cols);
            setArrManageGridCustomizeColoumns([...result]);
          } else {
            setArrManageGridCustomizeColoumns([...defaultColumns]);
          }
        } else {
          setArrManageGridCustomizeColoumns([...defaultColumns]);
        }
      } else { }
      //
      allColumns?.forEach((eachColumn) => {
        eachColumn.sSettings = { ...eachColumn?.sSettings, field: convertTOVariable(eachColumn?.sSettings?.field)?.toString() };
      });
      allColumns = bIsProd() ? allColumns?.filter((item) => item?.sSettings?.field !== "bracket_details.stoploss_price" && item?.sSettings?.field !== "bracket_details.profit_price" && item?.sSettings?.field !== "bracket_details.stoploss_trigger_price" && item?.sSettings?.field !== "bracket_details.ltp_jump_price" && item?.sSettings?.field !== "bracket_details.stoploss_jump_price" && item?.sSettings?.field !== "exit_price" && item?.sSettings?.field !== "bracket_details.bo_order_id") : allColumns;//Azeem K : 31-07-2025 : Hiding Cover and Bracket order for production
      setArrAllColumns([...allColumns]);
      //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
      setNonFilteredALlColumns([...allColumns]);
      //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - End
    } else {
      setSelectedViewTypePRofile([]);
      setArrAllColumns([]);
    }
  }, [columnViewType, objViewWiseColumnProfiles, userColumnProfiles, arrColumnMoviedTypess]);
  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End


  //Ameersha N :- this useeffect filters out column withs fixed and all column types based on view type - start
  useEffect(() => {
    switch (columnViewType) {
      case MANAGE_COLUMNS_VIEW_TYPES?.WATCHLIST_VIEW_TYPE:
        setStrModalNameViewType('Watchlist');
        break;
      case MANAGE_COLUMNS_VIEW_TYPES?.HOLDINGS_VIEW_TYPE:
        setStrModalNameViewType('Holdings');
        break; // need to add one case for holding manage columns to show manage columns name in modal title
      case MANAGE_COLUMNS_VIEW_TYPES?.CONSTITUENTS_VIEW_TYPE:
        setStrModalNameViewType('Constituents');
        break;
      case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_EQUITY_SIP_VIEW_TYPE:
        setStrModalNameViewType('Equity SIP');
        break;
      case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SINGLE_SCRIP_VIEW_TYPE:
        setStrModalNameViewType('Order Single Scrip');
        break;
      case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SPREAD_VIEW_TYPE:
        setStrModalNameViewType('Order Spread');
        break;
      case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_MULTI_LEG_VIEW_TYPE:
        setStrModalNameViewType('Order Multi Leg');
        break;
      case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_GOOD_TILL_DATE_VIEW_TYPE:
        setStrModalNameViewType('Order Good Till Date');
        break;
      case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_GOOD_TILL_TRIGGER_VIEW_TYPE:
        setStrModalNameViewType('Order Good Till Trigger');
        break;
      case MANAGE_COLUMNS_VIEW_TYPES?.NET_POSITION_VIEW_TYPE:
        setStrModalNameViewType('Netposition');
        break;
      case MANAGE_COLUMNS_VIEW_TYPES?.FUTURES_VIEW_TYPE:
        setStrModalNameViewType('Futures');
        break;
      default:
        setStrModalNameViewType('');
        break;
    }
    if (columnViewType?.length > 0) {
      setandFixFixedAndAllColumns();
    } else {

    }
  }, [columnViewType, setandFixFixedAndAllColumns]);
  //Ameersha N :- this useeffect filters out column withs fixed and all column types based on view type - start

  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
  const filterColumnsProfiles = useMemo(() => {
    let filteredProfiles = userColumnProfiles?.filter((eachProfile) => eachProfile?.sViewType === columnViewType);
    if (filteredProfiles?.length > 0) {
      return filteredProfiles;
    } else if (selected?.length <= 0 && filteredProfiles?.length > 0) {
      return filteredProfiles;
    }
    else {
      return [];
    }
  }
    , [userColumnProfiles, columnViewType, selected]);
  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End

  function hasCommonName(array1, array2) {
    //sColumnName

    if (array1?.length !== array2?.length) {
      return true;
    } else {
      let names1 = array1?.map(obj => obj?.sColumnName);
      let names2 = array2?.map(obj => obj?.sColumnName);
      let set1 = new Set(names1); // all fixed and customised columns
      let set2 = new Set(names2); // columsn of user profile

      for (let name of set1) {
        if (!set2?.has(name)) {
          return true;
        }
      }
      return false;
    }

  }

  useEffect(() => {
    // if alredy columsn are same then disable if added or removed extra columsn then undisable
    let abc = [...arrFixedColumns, ...customizeColoumns];
    const containes = hasCommonName(abc, filterColumnsProfiles[0]?.columnDetails);
    if (isDisableBtnInSort || containes) {
      setIsDisabledButton(false);
    } else if (!containes) {
      setIsDisabledButton(!containes);
    }
  }, [filterColumnsProfiles, arrFixedColumns, isDisableBtnInSort, customizeColoumns, defaultManageColumnName]);



  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
  const existsInarrFixedColumnsArray = useCallback((obj, isUpdate = false, columns) => {
    if (isUpdate) {
      return columns?.some((item) => item?.sColumnName?.toLowerCase() === obj?.sColumnName?.toLowerCase());
    } else {

      return arrFixedColumns?.some((item) => item?.sColumnName?.toLowerCase() === obj?.sColumnName?.toLowerCase());
    }
  }, [arrFixedColumns]);
  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End

  function rearrangeByColumnName(sourceArray, sequenceArray) {
    const sourceMap = new Map(sourceArray.map(item => [item.sSettings.field, item]));
    let reorderedArray = [];
    sequenceArray.forEach(seqItem => {
      if (sourceMap.get(seqItem.field)) {
        reorderedArray.push(sourceMap.get(seqItem.field));
      }
    });

    return reorderedArray;
  }

  //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  //Selects the column profiel which was selected from dropdown
  const onSelectColumnProfile = useCallback((e) => {
    if (e?.length > 0) {
      setSelectedProfile(e);
      setSelected(e[0]?.sColumnProfileName);
      // filter out fixed columns here
      let selectedProfileColumns = e[0]?.columnDetails;
      //set allColumns here
      setArrAllColumns(prevState => {
        const arrFilteredColumns = nonFilteredAllColumns?.filter((obj) => !existsInarrFixedColumnsArray(obj, true, selectedProfileColumns));
        return arrFilteredColumns;
      });
      const filteredColumns = selectedProfileColumns?.filter((obj) => !existsInarrFixedColumnsArray(obj));
      if (arrColumnMoviedTypess?.length > 0) {
        let objMovedColumnType = arrColumnMoviedTypess?.find((obj) => obj?.viewType === columnViewType);
        if (objMovedColumnType) {
          const result = rearrangeByColumnName(filteredColumns, objMovedColumnType?.cols);
          setArrManageGridCustomizeColoumns([...result]);
        } else {
          setArrManageGridCustomizeColoumns([...filteredColumns]);
        }
      } else {
        setArrManageGridCustomizeColoumns([...filteredColumns]);
      }

    } else { }
  }, [setArrManageGridCustomizeColoumns, arrColumnMoviedTypess, nonFilteredAllColumns, existsInarrFixedColumnsArray, columnViewType]);
  //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - End

  //Ameersha N : 22-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  useEffect(() => {
    if (columnViewType?.length > 0) {
      setTimeout(() => {
        if (Object?.keys(activeWatchList)?.length > 0) { //Hari k: isActive condition removed for tempoary
          let activeColumnProfileId = JSON.parse(deepClone(activeWatchList)?.sSettings)?.columnPofileId;
          let nIndex = filterColumnsProfiles?.findIndex(eachProfile => eachProfile?.id === activeColumnProfileId);
          let defaultProfile = filterColumnsProfiles?.find(eachProfile => eachProfile?.bIsDefault);
          if (nIndex >= 0) {
            onSelectColumnProfile([filterColumnsProfiles[nIndex]]);
          } else if (defaultProfile) {
            onSelectColumnProfile([defaultProfile]);
          }
          setIsActive(false);
        } else { }

      }, 200);
    } else { }
  }, [activeWatchList, columnViewType, filterColumnsProfiles, onSelectColumnProfile, userColumnProfiles]);
  //Ameersha N : 22-11-2023 : BT-96552 - Breeze - Manage Columns  - End
  useEffect(() => { // Hari :14-11-2024 setting is active true on unmounting phase if state not set true
    return () => {
      setIsActive(true);
    };
  }, []);
  //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  //This function will delete the column profile accordingly
  const onDeleteColumnProfile = useCallback((e, selectedColumn) => {
    e?.stopPropagation();
    if (selectedColumn?.bIsDefault) {
      dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Cannot delete default column profile' }));
    } else {
      dispatch(deleteUserColumnProfileAction({ id: selectedColumn?.id, version: selectedColumn?._version })).then(() => {
        if (selected?.toLowerCase() === selectedColumn?.sColumnProfileName?.toLowerCase()) {
          setSelected('');
        } else { }
        if (selectedProfile?.length > 0 && selectedProfile[0]?.sColumnProfileName?.toLowerCase() === selectedColumn?.sColumnProfileName?.toLowerCase()) {
          setArrSelectedPRofile([]);
          setSelectedProfile([]);
          setArrManageGridCustomizeColoumns([]);
        } else { }
        dispatch(toastConfig({ autoDismiss: true, show: true, message: `${selectedColumn?.sColumnProfileName} has been deleted successfully !` }));
      });
    }
  }, [dispatch, selected, selectedProfile]);
  //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - End

  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
  //This function will the column profile as default
  const onSetDefaultColumns = useCallback((e, selectedColumn) => {
    e?.stopPropagation();
    setIsDropDown(false);
    if (!selectedColumn?.bIsDefault) {
      const objPrevDefaultColumnProfile = filterColumnsProfiles?.find(eachColumn => eachColumn?.bIsDefault);
      if (objPrevDefaultColumnProfile && Object?.keys(objPrevDefaultColumnProfile)?.length > 0 && objPrevDefaultColumnProfile !== null && objPrevDefaultColumnProfile !== undefined) {
        objPrevDefaultColumnProfile.bIsDefault = false;
        dispatch(updateUserColumnProfileAction(objPrevDefaultColumnProfile))?.then(() => {
          selectedColumn.bIsDefault = true;
          dispatch(updateUserColumnProfileAction(selectedColumn))?.then(() => {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `${selectedColumn?.sColumnProfileName} has been set to default column profile !` }));
          });
        });
      }
      else {
        selectedColumn.bIsDefault = true;
        dispatch(updateUserColumnProfileAction(selectedColumn))?.then(() => {
          dispatch(toastConfig({ autoDismiss: true, show: true, message: `${selectedColumn?.sColumnProfileName} has been set to default column profile !` }));
        });
      }
    } else {

    }

  }, [filterColumnsProfiles, dispatch]);
  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End


  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  //This function will run when we click on save and apply either creates new profile if name was given opr updates existing column if profile is selected from dropwdown
  const onManageColumns = useCallback(async (e) => {
    const copyOfPrevousColumns = filterColumnsProfiles[0]?.columnDetails;
    e?.preventDefault();
    const isUpdateCurrentWatchlist = columnViewType === MANAGE_COLUMNS_VIEW_TYPES?.WATCHLIST_VIEW_TYPE ? true : false;
    const copyofFIxed = deepClone(arrFixedColumns);
    const copyOFCustomiseColumns = deepClone(customizeColoumns);
    const selectedColumns = [...copyofFIxed, ...copyOFCustomiseColumns];
    if (filterColumnsProfiles?.length > 0) {
      let seletecProfileCopy = filterColumnsProfiles[0];
      seletecProfileCopy['sViewType'] = columnViewType;
      selectedColumns?.forEach((eachColumn, index) => {
        eachColumn.isPinned = 0;
        eachColumn.nSequenceNo = (index + 1);
      });
      seletecProfileCopy['columnDetails'] = selectedColumns;
      dispatch(updateUserColumnProfileAction(seletecProfileCopy, isUpdateCurrentWatchlist, true))?.then((res) => {
        if (res?.data?.status === API_RESPONSE_STATUS.SUCCESS) {

          setStrMsg(defaultManageColumnName);
          dispatch(handleModal([
            { 'MANAGE_COLUMNS_MODAL_STATUS': true },
            { 'WATCHLIST_MANAGE_COLUMNS_MODAL': false }]));
          setTimeout(() => {
            setStrMsg('');
            setIsDisableBtnInSort(false);
            setArrManageGridCustomizeColoumns([]);
            dispatch(updateStrViewType(''));
            dispatch(handleModal([{ 'MANAGE_COLUMNS_MODAL_STATUS': false }]));

          }, 1000);
        } else { }
      })?.catch(() => {
        seletecProfileCopy['columnDetails'] = copyOfPrevousColumns;
        dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Changes were not saved, Please try again. ' }));
      });
    } else {
      //Create profile by hardcoded value
      selectedColumns?.forEach((eachColumn, index) => {
        eachColumn.isPinned = 0;
        eachColumn.nSequenceNo = (index + 1);
        eachColumn.sSettings = typeof (eachColumn.sSettings) === 'string' ? eachColumn.sSettings : JSON?.stringify(eachColumn.sSettings);
      });
      const objColumnPayload = {
        sColumnProfileName: defaultManageColumnName,
        sViewType: columnViewType,
        bIsDefault: isColumnPresent && filterColumnsProfiles?.length <= 0 ? true : false,
        columnDetails: selectedColumns,
        sSettings: ''
      };
      dispatch(createUserColumnProfileAction(objColumnPayload, isUpdateCurrentWatchlist))?.then((res) => {
        if (res?.data?.status === API_RESPONSE_STATUS.SUCCESS) {
          setStrMsg(objColumnPayload?.sColumnProfileName);
          dispatch(handleModal([
            { 'MANAGE_COLUMNS_MODAL_STATUS': true },
            { 'WATCHLIST_MANAGE_COLUMNS_MODAL': false }]));
          setTimeout(() => {
            dispatch(handleModal([{ 'MANAGE_COLUMNS_MODAL_STATUS': false }]));
            setProfileName('');
            setArrManageGridCustomizeColoumns([]);
            setStrMsg('');
            dispatch(updateStrViewType(''));
          }, 1000);
        } else { }
      })?.catch(() => {
        dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Changes were not saved, Please try again. ' }));
      });
    }
    //Ameersha N: 9-07-2024 : Bt-96552 - Breeze DO NOT DELETE THIS CODE [THIS CODE FOR MULTIPLE COLUMN PROFILE CREATION] --Start
    ///
    //
    // if (profileName?.length > 0) {//Ameersha N : 12-12-2023 : BT-96552 - Breeze - Manage Columns   :issue :- not creating new profile its updating instead -Fixed
    //   // creating new column profile
    //   selectedColumns?.forEach((eachColumn, index) => {
    //     eachColumn.isPinned = 0;
    //     eachColumn.nSequenceNo = (index + 1);
    //     eachColumn.sSettings = typeof (eachColumn.sSettings) === 'string' ? eachColumn.sSettings : JSON?.stringify(eachColumn.sSettings);
    //   });
    //   const objColumnPayload = {
    //     sColumnProfileName: profileName?.toUpperCase(),
    //     sViewType: columnViewType,
    //     bIsDefault: isColumnPresent && filterColumnsProfiles?.length <= 0 ? true : false,
    //     columnDetails: selectedColumns,
    //     sSettings: ''
    //   };
    //   dispatch(createUserColumnProfileAction(objColumnPayload, isUpdateCurrentWatchlist))?.then(() => {
    //     setStrMsg(objColumnPayload?.sColumnProfileName);
    //     dispatch(handleModal([
    //       { 'MANAGE_COLUMNS_MODAL_STATUS': true },
    //       { 'WATCHLIST_MANAGE_COLUMNS_MODAL': false }]));
    //     setTimeout(() => {
    //       dispatch(handleModal([{ 'MANAGE_COLUMNS_MODAL_STATUS': false }]));
    //       setProfileName('');
    //       setArrManageGridCustomizeColoumns([]);
    //       setStrMsg('');
    //     }, 2000);

    //   });
    //   //creating as new profile
    // } else if (selectedProfile?.length > 0 && profileName?.length <= 0) {//Ameersha N : 12-12-2023 : BT-96552 - Breeze - Manage Columns   :issue :- not creating new profile its updating instead -Fixed
    //   // updating column profile
    //   let seletecProfileCopy = selectedProfile[0];
    //   seletecProfileCopy['sViewType'] = columnViewType;
    //   selectedColumns?.forEach((eachColumn, index) => {
    //     eachColumn.isPinned = 0;
    //     eachColumn.nSequenceNo = (index + 1);
    //   });
    //   seletecProfileCopy['columnDetails'] = selectedColumns;
    //   dispatch(updateUserColumnProfileAction(seletecProfileCopy, isUpdateCurrentWatchlist, true))?.then(() => {
    //     setStrMsg(seletecProfileCopy?.sColumnProfileName);
    //     dispatch(handleModal([
    //       { 'MANAGE_COLUMNS_MODAL_STATUS': true },
    //       { 'WATCHLIST_MANAGE_COLUMNS_MODAL': false }]));
    //     setTimeout(() => {
    //       dispatch(handleModal([{ 'MANAGE_COLUMNS_MODAL_STATUS': false }]));
    //       setStrMsg('');
    //       setArrManageGridCustomizeColoumns([]);
    //     }, 2000);
    //   });
    //   // give columns id in activeWatchlist sSeetings and update current watchlist
    //   //create new column profile in columns api
    // }
    ///
    ///
    ///
    //Ameersha N: 9-07-2024 : Bt-96552 - Breeze DO NOT DELETE THIS CODE [THIS CODE FOR MULTIPLE COLUMN PROFILE CREATION] --End
    // dispatch(handleModal([{ "WATCHLIST_MANAGE_COLUMNS_MODAL": false }]));
    // setArrManageGridCustomizeColoumns([]);
    // setSelectedProfile([]);
    // setArrAllColumns([]);
    // setStrModalNameViewType('');
    setSelected('');
    setTimeout(() => {
      setIsActive(true);
    }, 2000);
  }, [
    defaultManageColumnName,
    arrFixedColumns,
    customizeColoumns, setArrManageGridCustomizeColoumns, filterColumnsProfiles,
    columnViewType, dispatch
    //  selectedProfile, profileName,
    // isColumnPresent, 
    // setProfileName
  ]);
  //Ameersha N : 23-11-2023 : BT-96552 - Breeze - Manage Columns  - End





  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
  //Deletes selected column from customsiable columns
  const deleteCustomisableColumns = useCallback((e, column) => {
    let columnsCopy = customizeColoumns;
    let nIndex = columnsCopy?.findIndex((eacColumn => eacColumn?.sColumnName?.toLowerCase() === column?.sColumnName?.toLowerCase()));
    if (nIndex >= 0) {
      const deletedColumn = columnsCopy?.splice(nIndex, 1);
      setArrManageGridCustomizeColoumns([...columnsCopy]);
      setArrAllColumns(prevState => {
        const arrUpadtedAllColumns = [...prevState, deletedColumn[0]];
        return arrUpadtedAllColumns;
      });
    } else { }
  }, [setArrManageGridCustomizeColoumns, customizeColoumns]);
  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End


  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
  const handleCheckBox = (e, subItem) => {
    if (e.target.checked) {
      setArrManageGridCustomizeColoumns([...customizeColoumns, subItem]);
    }
    else {
      const updatedColumns = customizeColoumns?.filter(column => column !== subItem);
      setArrManageGridCustomizeColoumns(updatedColumns);
    }
  };
  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End

  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
  //Thsi will add the selected columns from left side container to right side customisable container
  const handleAddingColumnsToCustomisable = useCallback((e, item) => {
    e?.preventDefault();
    setArrManageGridCustomizeColoumns(prevState => {
      let zIndex = arrAllColoumns?.findIndex((eachColumn) => (eachColumn?.sColumnName?.toLowerCase() === item?.sColumnName?.toLowerCase()));
      setArrAllColumns(prevState => {
        if (zIndex >= 0) {
          prevState?.splice(zIndex, 1);
          return prevState;
        } else { }
      });

      let nIndex = prevState?.findIndex((eachColumn) => (eachColumn?.sColumnName?.toLowerCase() === item?.sColumnName?.toLowerCase()));
      let aIndex = arrFixedColumns?.findIndex((eachColumn) => (eachColumn?.sColumnName?.toLowerCase() === item?.sColumnName?.toLowerCase()));
      if (item?.sColumnName === 'Pivot' && nIndex < 0) {
        return [...prevState, ...item?.data];
      } else if (item?.sColumnName !== 'Pivot' && nIndex < 0 && aIndex < 0) {
        return [...prevState, item];
      }
      else {
        return [...prevState];
      }
    });
  }, [setArrManageGridCustomizeColoumns, arrFixedColumns, arrAllColoumns]);
  //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Ends

  //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - Start
  const handleOnInputChange = useCallback((e) => {

    if (e?.length <= 20) {
      if (!_checkForSpecialChars(e)?.status) {
        setSelected(e);
      } else { }

    } else {

    }
    if (e?.length <= 0) {
      setandFixFixedAndAllColumns();
      setProfileName('');
      setSelectedProfile([]);
      setArrManageGridCustomizeColoumns([]);
    } else { }
    if (e?.length <= 20) {
      useDebounce(() => {
        const matchedProfile = filterColumnsProfiles?.find((eachProfile) => eachProfile?.sColumnProfileName?.toLowerCase() === e?.toLowerCase());
        if (matchedProfile && Object?.keys(matchedProfile)?.length > 0 && matchedProfile !== undefined) {
          onSelectColumnProfile([matchedProfile]);
          setProfileName('');
          setIsDropDown(false);

          // close dropdown
        } else {
          if (e?.length <= 20) {
            if (!_checkForSpecialChars(e)?.status) {
              setProfileName(e?.toUpperCase());
            } else { }
          } else { }

        }

      }, 1000);
    } else { }


  }, [filterColumnsProfiles, setandFixFixedAndAllColumns, onSelectColumnProfile]);
  //Ameersha N : 20-11-2023 : BT-96552 - Breeze - Manage Columns  - End

  const renderCustomInput = (inputProps) => {
    return (
      <input {...inputProps} value={selected?.toUpperCase()} className='form-control form-control-sm font-regular bdr-none py-0 px-0' onChange={(e) => handleOnInputChange(e?.target?.value)} />
    );
  };



  //Ameersha N : 31-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
  useEffect(() => {
    if (selected?.length <= 0) {
      setArrSelectedPRofile([]);
    } else { }
  }, [selected]);
  //Ameersha N : 31-10-2023 : BT-96552 - Breeze - Manage Columns  - End

  return (
    <>

      <ManageColumnStatusModal msgContent={strMsg} />

      <form onSubmit={(e) => e?.preventDefault()}>

        <BzModal data-testid="manage-column-modal" size='lg' className='manage-column' show={modals['WATCHLIST_MANAGE_COLUMNS_MODAL']} onHide={handleHide} centered>
          <BzModalHeader className='modaltabs-header'>
            <Container fluid className='p-0'>
              <Row className='g-0'>
                <Col md={11} className='d-flex justify-content-start align-items-center'>
                  <BzModalTitle data-testid="manage-column-tittle" className='font-medium font-size5 color-text'>Manage Columns</BzModalTitle>
                </Col>
                {/* <Col md={1}>
                  <button onClick={(e) => onDeleteColumnProfile(e, userColumnProfiles?.filter((eachProfile) => eachProfile?.sViewType === columnViewType)[0])}>Delete profile</button>
                </Col> */}
                <Col md={1} className='d-flex justify-content-end align-self-center'>
                  <div data-testid="manage-column-modal-close-icon" className='icon-16 icon-close icon-dark ms-3' onClick={handleHide}></div>
                </Col>
              </Row>
            </Container>
          </BzModalHeader>
          <BzModalBody>
            <Container fluid className='p-0'>
              <Row className='g-0'>
                <Col md={12}>
                  <ManageColumns
                    strModalNameViewType={strModalNameViewType}
                    deleteCustomisableColumns={deleteCustomisableColumns} handleCheckBox={handleCheckBox}
                    handleAddingColumnsToCustomisable={handleAddingColumnsToCustomisable}
                    arrAllColoumns={arrAllColoumns} arrFixedColumns={arrFixedColumns} customizeColoumns={customizeColoumns}
                    setArrManageGridCustomizeColoumns={setArrManageGridCustomizeColoumns}
                    objViewWiseColumnProfiles={objViewWiseColumnProfiles}
                    columnViewType={columnViewType}
                    userColumnProfiles={userColumnProfiles}
                    existsInarrFixedColumnsArray={existsInarrFixedColumnsArray}
                    setIsDisableBtnInSort={setIsDisableBtnInSort}
                  />
                </Col>
              </Row>
            </Container>
          </BzModalBody>

          <BzModalFooter className='px-3 pb-3 manage-column-footer'>
            <Container fluid className='p-0'>
              <Row className='g-0'>
                <Col md={1}>&nbsp;</Col>
                <Col className='d-flex justify-content-end align-items-center'>


                  {/* <div className='d-flex align-items-center'>
                    <div className='font-regular font-size3 color-text text-nowrap me-2'>Column Profile Name:</div>
                    <div>
                      <Row className='g-0'>
                        <Col className='d-flex align-items-center'>
                          <div className='d-flex justify-content-end align-items-center'>
                            <div className='d-flex form-control form-control-sm p-0 align-items-center' onClick={() => setIsDropDown(prev => !prev)}>
                              <Typeahead
                                renderInput={renderCustomInput}

                                labelKey='sColumnProfileName'
                                open={isDropDown}
                                onBlur={() => setIsDropDown(false)}
                                selected={arrSelectedProfile}
                                className='form-control form-control-sm font-regular bdr-none py-0' id="city"
                                ref={profileNameRef} options={filterColumnsProfiles || []}
                                onChange={(e) => { onSelectColumnProfile(e); setIsDropDown(false); }}
                                onInputChange={handleOnInputChange}
                                clearButton

                                placeholder="Type name here/choose" renderMenuItemChildren={(option) => (
                                  <Row className='g-0'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                      <div className='font-medium font-size2 color-text text-truncate'>{option?.sColumnProfileName}</div>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-items-center'>

                                      {!option?.bIsDefault ? <div className='icon-16 icon-delete icon-dark' onClick={(e) => onDeleteColumnProfile(e, option)}></div> : null}
                                      <div className='font-medium font-size3 color-primary cursor-pointer ms-3 p-t-3' onClick={(e) => onSetDefaultColumns(e, option)}>{option?.bIsDefault ? 'Default' : 'Set Default'}</div>
                                      {option?.bIsDefault ? <div className='icon-16 icon-checktick icon-primary ms-2'></div> : null}
                                    </Col>
                                  </Row>
                                )} >

                                {/* {({ onClear }) => (
                                  <ClearButton onClick={(e) => {
                                    onClear();
                                    setSelected('');
                                  }} />
                                )} */}
                  {/* </Typeahead>
                              <div className='d-flex flex-column pe-2'>
                                <div className='icon-12 icon-arrowdown icon-dark'></div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div> */}
                </Col>
                <Col md={2} className='d-flex justify-content-end align-items-center ms-3'>
                  <BzButton data-testid="manage-column-save-btn" className='btn btn-md btn-primary btn-block text-uppercase' onClick={onManageColumns}
                    disabled={isDisabledButton}
                  >SAVE & APPLY</BzButton>
                </Col>
              </Row>
            </Container>
          </BzModalFooter>

        </BzModal>


      </form>

    </>

  );
};

export default memo(GridManageColumnsModal);